<template>
  <div ref="chatQuestions" v-if="lastMessageSelections && lastMessageSelections?.length" class="chat-selection">
    <button v-for="(selection, index) in lastMessageSelections" :key="index" class="chat-selection-item"
      :class="[selection.action === 'next_step' ? 'action_next' : '', selection.action_style ? selection.action_style : '']"
      @click="
    buttonClick({
      text: $t(selection.name),
      value: selection.value,
      text_without_t: selection.name,
      action: selection.action,
      ai_question: $t(selection.ai_question),
    })
    " :disabled="disabled">
      <i v-if="qcmResultsKeys.includes(selection.value)" class="material-icons check-done">check_circle</i>
      {{ $t(selection.name) }}
    </button>
  </div>
</template>

<script>
import utils from "../utils";
import { customLogger } from "@/utils";
export default {
  name: "Selection",
  components: {
  },
  data: () => {
    return {
    };
  },
  props: {
    selection: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    this.scrollToBottom();
    if (this.lastMessageSelections && this.lastMessageSelections?.length && this.goNextStep) {
      customLogger("activate the button for next step");
    }
  },
  computed: {
    qcmResultsKeys() {
      return this.$store.state.user?.data?.qcm_results ? Object.keys(this.$store.state.user.data.qcm_results) : [];
    },
    lastMessageSelections() {
      let selections = [];
      const length = this.$store.state.user.messages.length;
      const messages = this.$store.state.user.messages;

      if (messages[length - 1] && messages[length - 1]?.content?.selection) {
        selections = messages[length - 1].content.selection;
      }

      return selections;
    },
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        utils.scrollDown();
      });
    },
    buttonClick(button) {
      this.$eb.emit(
        "StyleButtonClick",
        button,
        this.$store.state.user.data.tmp_content
      );
    },
  },
};
</script>
